import React from 'react'
import { AlertTriangle } from 'lucide-react'
import { Alert, AlertDescription } from '../ui/alert'
import { textoDeportesFaltantes } from '../../lib/deportesFaltantes'

// Sin faltantes, o sin el dato (antes de la migracion 20261002), no pinta nada.
const AvisoDeportesFaltantes = ({ deportes, className = '' }) => {
  const texto = textoDeportesFaltantes(deportes)
  if (!texto) return null
  return (
    <Alert className={`border-amber-300 bg-amber-50 text-amber-900 [&>svg]:text-amber-600 ${className}`}>
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription className="text-xs">{texto}</AlertDescription>
    </Alert>
  )
}

export default AvisoDeportesFaltantes
